import React from 'react';
import { Route, Switch, Redirect, useRouteMatch } from 'react-router-dom';

// components
import ListClientPage from './ListClientPage';

const OrderRouter = () => {
  const match = useRouteMatch();

  return (
    <Switch>
      <Route exact path={`${match.url}/`} component={ListClientPage} />
      <Redirect to={`${match.url}/`} />
    </Switch>
  );
};

export default OrderRouter;
